export enum ProfileLinkedAccountAccountType {
	CHECKING = 'checking',
	SAVINGS = 'savings',
}
